/**
 * Whether this build checks for and installs OTA bundles when the app comes to the foreground.
 *
 * On for every GitLab pipeline build: `vite.config.ts` sets `VITE_APP_OTA_UPDATES` whenever
 * `GITLAB_CI` is present, which covers the `build` job whose `build/` artifact the native
 * test builds embed. Off for a local build, which would otherwise be replaced by whatever
 * bundle its channel offers, since any released version counts as newer than a local one.
 * `npm run build:updateTest` turns it back on to exercise OTA locally.
 */
export const otaUpdatesEnabled = (): boolean => import.meta.env.VITE_APP_OTA_UPDATES === "true";
